var render = function render(){var _vm=this,_c=_vm._self._c;return _c('apexchart',{staticClass:"apex-charts",attrs:{"height":"300","type":"line","series":_vm.series,"options":_vm.options}})
}
var staticRenderFns = []

export { render, staticRenderFns }